import React from 'react';
import { Typography } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown, People } from '@mui/icons-material';

import { translateStatus } from '../../../../config/constants';

import './MarketersTable.css';
import { MarketersTableProps } from './MarketersTable.types';

/**
 * Displays a table of sales experts (marketers) with expandable station details

 */
export const MarketersTable = ({
  experts,
  currentExpert,
  onToggleExpansion,
  onExclusionChange,
  bodyRef
}: MarketersTableProps) => {
  if (experts.length == 0) {
    return (
      <div className="marketers-table-no-data">
        <People className="marketers-table-no-data-icon" />
        <Typography>Маркетологів не знайдено</Typography>
      </div>
    );
  }

  return (
    <div className="marketers-table-wrapper" ref={bodyRef}>
      <table className="marketers-table">
        <tbody>
          {experts.map(expert => (
            <React.Fragment key={expert.expert_email}>
              <tr
                className="marketers-table-row marketers-table-expert-main-row"
                onClick={() => onToggleExpansion(expert.expert_email)}
              >
                <td className="marketers-table-cell um-col-expert-email">{expert.expert_email}</td>
                <td className="marketers-table-cell um-col-expert-name">
                  {expert.expert_name} {expert.expert_surname}
                </td>
                <td className="marketers-table-cell um-col-expert-phone">
                  <div className="marketers-table-expert-cell-content">
                    <span className="marketers-table-expert-phone">{expert.expert_phone}</span>
                    <div className="marketers-table-expert-toggle">
                      {currentExpert && currentExpert.expert_email === expert.expert_email ? (
                        <KeyboardArrowUp />
                      ) : (
                        <KeyboardArrowDown />
                      )}
                    </div>
                  </div>
                </td>
              </tr>
              {currentExpert && currentExpert.expert_email === expert.expert_email && (
                <tr className="marketers-table-stations-subrow">
                  <td colSpan={3} className="marketers-table-stations-cell">
                    <div className="marketers-table-stations-container">
                      <div className="marketers-table-stations-header">
                        <div className="col-unicode">Юнікод</div>
                        <div className="col-number">№ АЗК</div>
                        <div className="col-email">Пошта АЗК</div>
                        <div className="col-address">Адреса</div>
                        <div className="col-region">Регіон</div>
                        <div className="col-province">Область</div>
                        <div className="col-status">Статус</div>
                        <div className="col-excluded">Включено</div>
                      </div>
                      {currentExpert.stations.map((station: any) => (
                        <div key={station.unicode} className="marketers-table-station-row">
                          <div className="col-unicode">{station.unicode}</div>
                          <div className="col-number">{station.nomer}</div>
                          <div className="col-email">{station.azk_email}</div>
                          <div className="col-address">
                            {station.address?.settlement_name}, {station.address?.street} {station.address?.build_nom}
                          </div>
                          <div className="col-region">{station.regional_office}</div>
                          <div className="col-province">{station.province}</div>
                          <div className="col-status">{translateStatus(station.status?.azk_status)}</div>
                          <div className="col-excluded">
                            <input
                              type="checkbox"
                              checked={station.active}
                              onChange={e => onExclusionChange(expert.expert_email, station.unicode, e.target.checked)}
                              className="marketers-table-exclusion-checkbox"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};
